import { ApiService } from 'projects/services/src/app/API/api.service';
import { environment } from 'src/environments/environment';
import { Component, OnInit, Input } from '@angular/core';
import { FileService } from 'projects/services/src/app/API/document/file.service';

@Component({
	selector: 'app-file-download',
	templateUrl: './file-download.component.html',
	styleUrls: ['./file-download.component.css']
})
export class FileDownloadComponent implements OnInit {
	@Input() fileURL: any;
	@Input() buttonText = 'Download';
	@Input() buttonTag;
	@Input() FileinputDisabled;
	@Input() isSignedUrlRequired = true;

	mutipleFileURLs: any = [];
	@Input() publicUrl= false;
	constructor(
		private apiService: ApiService,
		private fileService: FileService) { }

	ngOnInit() { }
	// TO download attached file
	downloadAttachedFile(url?: any, __filename?) {
		if (this.publicUrl) {
			return this.fileService.downloadFromUrl(url, __filename);
		}
		if (url) {
			this.fileURL = url;
		}
		if (this.fileURL === undefined) {
			return;
		}
		const isArr = Array.isArray(this.fileURL);
		if (!isArr) {
			if (this.fileURL.includes('.com/')) {
				this.fileURL = this.fileURL.split('.com/').pop();
			}
			const documentDOwnloadURL =
				environment.documentServiceUrl +
				'/api/document/v1/signedURL?key=' +
				encodeURIComponent(this.fileURL);
			if (this.isSignedUrlRequired) {
				this.apiService.get(documentDOwnloadURL).subscribe(signedURL => {
				const popupCheck = window.open('');
				if (popupCheck == null || typeof (popupCheck) === 'undefined') {
					alert('Please enable popup to open documents in new tab, Check in right side of browser url bar and allow');
					return true;
				} else {
					popupCheck.close();
					const a = document.createElement('a');
					document.body.appendChild(a);
					a.setAttribute('style', 'display: none');
					a.setAttribute('target', '_blank');
					a.href = signedURL;
					a.download = __filename;
					a.click();
					window.URL.revokeObjectURL(signedURL);
					a.remove();
					return false;
				}
			});
			} else {
				this.fileService.getS3SignedURLPublic(this.fileURL).subscribe(
					signedURL => {
						const popupCheck = window.open('');
					if (popupCheck == null || typeof (popupCheck) === 'undefined') {
						alert('Please enable popup to open documents in new tab, Check in right side of browser url bar and allow');
						return true;
					} else {
						popupCheck.close();
						const a = document.createElement('a');
						document.body.appendChild(a);
						a.setAttribute('style', 'display: none');
						a.setAttribute('target', '_blank');
						a.href = signedURL;
						a.download = __filename;
						a.click();
						window.URL.revokeObjectURL(signedURL);
						a.remove();
						return false;
					}
					}
				)
			}

		} else {
			this.getSignedURLForMultiDownload();
		}
	}
	getSignedURLForMultiDownload(__filename?) {
		this.fileURL.forEach(element => {
			if (element && element !== null) {
				const documentDOwnloadURL =
					environment.documentServiceUrl +
					'/api/document/v1/signedURL?key=' +
					encodeURIComponent(element);
				this.apiService.get(documentDOwnloadURL).subscribe(signedURL => {
					const popupCheck = window.open('');
					if (popupCheck == null || typeof (popupCheck) === 'undefined') {
						alert('Please enable popup to open documents in new tab, Check in right side of browser url bar and allow.');
						return true;
					} else {
						popupCheck.close();
						const a = document.createElement('a');
						document.body.appendChild(a);
						a.setAttribute('style', 'display: none');
						a.setAttribute('target', '_blank');
						a.href = signedURL;
						a.download = __filename;
						a.click();
						window.URL.revokeObjectURL(signedURL);
						a.remove();
						return false;
					}

				});
			}
		});
	}
}
